import React from "react";

import PropTypes from "prop-types";
import Select from "react-select";

import { getReactSelectTheme } from "../../utils/ReactSelectStyles";
import InstructionNotification from "../Notifications/InstructionNotification";
import SimpleNotification from "../Notifications/SimpleNotification";

const SelectTableForm = ({
    mainSelect,
    tableLabel,
    selectedData,
    emptySelectedPlaceholder,
    keys,
    headers,
    notificationMessage,
}) => {
    const renderHeader = () => {
        return (
            headers &&
            headers.map((header, index) => {
                return (
                    <td key={index}>
                        <div className="font-bold px-6 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">
                            <div className="flex items-center justify-center">
                                <span className="ml-2">{header}</span>
                            </div>
                        </div>
                    </td>
                );
            })
        );
    };

    const getKeyValue = (row, key, index) => {
        //Checking for sub keys for example user.organization.id
        if (key.element) return key.element(row, index);
        let rowValue = key.subKey ? row[key.name][key.subKey] : row[key.name];
        rowValue = key.parseMethod ? key.parseMethod(rowValue) : rowValue;
        return rowValue;
    };

    const renderSelectedModels = () => {
        const visibleRows = selectedData.filter((row) => !row.value.isDeleted);
        if (!visibleRows.length) {
            return (
                <InstructionNotification
                    colSpan={keys.length}
                    message={emptySelectedPlaceholder}
                />
            );
        }

        return selectedData.map((row, index) => {
            if (!row.value?.isDeleted) {
                const tds = keys?.map((key, keyIndex) => {
                    let rowValue = getKeyValue(row, key, index);
                    return <td key={keyIndex}>{rowValue}</td>;
                });

                return <tr key={index}>{tds}</tr>;
            }
        });
    };

    return (
        <>
            <div className="mb-4">
                <div className="main-customer-form-inputs">
                    <div className="input-group">
                        <label className="uppercase">{mainSelect.label}</label>
                        <Select
                            value=""
                            options={mainSelect.options}
                            isClearable={true}
                            onChange={mainSelect.onChangeHandler}
                            className="z-12"
                            placeholder={mainSelect.placeholder}
                            theme={getReactSelectTheme}
                        />
                    </div>
                </div>

                {notificationMessage && (
                    <SimpleNotification message={notificationMessage} />
                )}

                <div className="input-group">
                    <label htmlFor="scan-input-1" className="uppercase">
                        {tableLabel}
                    </label>
                </div>

                <div className="h-small-with-scroll table-responsive shadow overflow-hidden border-b border-gray-200 sm:rounded-lg small-scroll-x small-scroll-y">
                    <table className="table-striped min-w-full divide-y divide-gray-200 text-xs text-center w-full">
                        <thead className="parent-head">
                            <tr>{renderHeader()}</tr>
                        </thead>
                        <tbody>{renderSelectedModels()}</tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

SelectTableForm.Proptypes = {
    mainSelect: PropTypes.shape({
        label: PropTypes.PropTypes.string.isRequired,
        options: PropTypes.array.isRequired,
        onChangeHandler: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
    }),
    notificationMessage: PropTypes.string,
    tableLabel: PropTypes.node.isRequired,
    selectedData: PropTypes.array.isRequired,
    emptySelectedPlaceholder: PropTypes.string.isRequired,
    keys: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            element: PropTypes.func,
            subKey: PropTypes.string,
            parseMethod: PropTypes.func,
        })
    ).isRequired,
    headers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SelectTableForm;
